import script from "./DEMA.vue?vue&type=script&lang=js"
export * from "./DEMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__